import React, { useState } from "react";
import "./MenuScreen.css";

const SECTIONS = [
  {
    time: "Od godz. 15:00",
    title: "Fingerfoods w stodole",
    desc: "Przywitaj się z innymi gośćmi przy przekąskach i napojach.",
    items: [
      {
        name: "Mini burger z kurczakiem",
        desc: "W sosie BBQ, piklowany ogórek, curry mayo, sałata",
      },
      { name: "Szpinakowy naleśnik", desc: "Serek ziołowy, suszone pomidory" },
      {
        name: "Vol-au-vent z farszem łososiowym",
        desc: "Koper, palona limonka",
      },
    ],
  },
  {
    time: "Od godz. ok. 17:00",
    title: "Menu serwowane",
    items: [
      { name: "Domowy rosół", desc: "Z pieczonymi warzywami i krajanką" },
      {
        name: "Krem z białych warzyw (Danie tylko dla wegan)",
        desc: "Z białą czekoladą i oliwą truflową",
      },
      {
        name: "Devolay",
        desc: "Młode ziemniaki gotowane, surówka z młodej kapusty w stylu azja",
      },
      {
        name: "Stek z dyni piżmowej (Danie tylko dla wegan)",
        desc: "Czarna soczewica, suszone pomidory, salsa owocowo-warzywna",
      },
      {
        name: "Faworki drobiowe - danie dla dzieci",
        desc: "Z ziemniakami, surówka z marchewki i jabłka",
      },
      { name: "Ptyś z kremem truskawkowym", desc: "Owoce, puder miętowy" },
    ],
  },
  {
    time: "Od godz. 19:00",
    title: "Bufet słodki",
    items: [
      { name: "Ciasto czekoladowe", desc: "Z wiśniami" },
      { name: "Kruche ciasto", desc: "Z owocami, bezą i kruszonką" },
      { name: "Owoce filetowane", desc: "" },
      { name: "Sernik królewski", desc: "Z czekoladową kruszonką" },
    ],
  },
  {
    time: "Od godz. 19:30",
    title: "Bufet ciepły",
    items: [
      { name: "Zrazy wołowe", desc: "W sosie cebulowo-tymiankowym" },
      { name: "Indyk w sosie brzoskwiniowym", desc: "" },
      { name: "Curry z ciecierzycą i kolendrą", desc: "" },
      { name: "Gnocchi z oliwą truflową", desc: "" },
      { name: "Pieczone ziemniaki", desc: "W rozmarynie i papryce" },
      {
        name: "Fasolka szparagowa",
        desc: "W sosie teriyaki z prażonym sezamem",
      },
    ],
  },
  {
    time: "Od godz. 19:30",
    title: "Bufet zimny",
    items: [
      {
        name: "Sałata ze szpianku",
        desc: "Ser pleśniowy, prażone nasiona słonecznika",
      },
      { name: "Szpinakowy naleśnik", desc: "Serek ziołowy, suszone pomidory" },
      {
        name: "Vol-au-vent z farszem łososiowym",
        desc: "Koper, palona limonka",
      },
      {
        name: "Spring rolls z kurczakiem i warzywami",
        desc: "W sosie sweet chilli",
      },
      { name: "Ogórek faszerowany", desc: "Mus serowo-ziołowy z miętą" },
      { name: "Półmiski z wędzonymi wędlinami", desc: "Pikle, sosy" },
    ],
  },
  {
    time: "Po północy",
    title: "Danie po północy",
    items: [
      { name: "Barszcz czerwony", desc: "Z pasztecikiem z kapustą i grzybami" },
    ],
  },
];

export default function MenuScreen() {
  const [open, setOpen] = useState(null);

  return (
    <div className="screen">
      <div className="page-header">
        <h1 className="page-header__title">Karta Dań</h1>
        <p className="page-header__sub">Menu weselne</p>
      </div>

      <div className="screen__body">
        <div className="menu__list">
          {SECTIONS.map((section, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="menu__section">
                <button
                  className={`menu__section-header ${isOpen ? "menu__section-header--open" : ""}`}
                  onClick={() => setOpen(isOpen ? null : i)}
                >
                  <div className="menu__section-left">
                    <div>
                      <div className="menu__section-time">{section.time}</div>
                      <div className="menu__section-title">{section.title}</div>
                    </div>
                  </div>
                  <span className="menu__chevron">{isOpen ? "▲" : "▼"}</span>
                </button>

                {isOpen && (
                  <div className="menu__items">
                    {section.desc && (
                      <p className="menu__section-desc">{section.desc}</p>
                    )}
                    {section.items.map((item, j) => (
                      <div key={j} className="menu__item">
                        <div className="menu__item-name">{item.name}</div>
                        {item.desc && (
                          <div className="menu__item-desc">{item.desc}</div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
